// @flow
import { APICore } from './apiCore';
import config from '../../config';

const api = new APICore();

function readAllLocations(query) {
    let baseUrl = config.LOCATIONS_URL;

    if (typeof query === 'string') {
        baseUrl += `?${query}`;
    }

    return api.get(`${baseUrl}`, {});
}

function createLocation(locationRequest) {
    const baseUrl = config.LOCATIONS_URL;
    return api.create(`${baseUrl}`, locationRequest);
}

function updateLocation(locationId, locationRequest) {
    const baseUrl = config.LOCATIONS_URL + '/' + locationId;
    return api.update(`${baseUrl}`, locationRequest);
}

function deleteLocation(locationId) {
    const baseUrl = config.LOCATIONS_URL + '/' + locationId;
    return api.delete(`${baseUrl}`, {});
}

export {
    readAllLocations,
    createLocation,
    updateLocation,
    deleteLocation,
};